(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // Products travel right-to-left along the top of a large circle: upright at the centre, dropping and leaning outwards along the curve towards the edges.
  if (!customElements.get('cart-empty-carousel')) {
    class CartEmptyCarousel extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.cart-drawer__empty-welcome-product')];
        if (!this.items.length) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.offset = 0;
        this.last = performance.now();
        this.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') this.paused = true; });
        this.addEventListener('pointerleave', () => { this.paused = false; });
        this.tick = (now) => {
          const elapsed = Math.min(64, now - this.last);
          this.last = now;
          if (this.offsetParent !== null) {
            if (!this.paused && !this.motion.matches) this.offset += 26 * elapsed / 1000;
            this.layout();
          }
          this.frame = requestAnimationFrame(this.tick);
        };
        this.frame = requestAnimationFrame(this.tick);
      }
      disconnectedCallback() { cancelAnimationFrame(this.frame); }
      layout() {
        const spacing = 86;
        const radius = 600;
        const width = this.clientWidth;
        const total = Math.max(this.items.length * spacing, width + spacing * 2);
        this.items.forEach((item, index) => {
          const x = (((index * spacing - this.offset) % total) + total) % total - spacing;
          const dx = Math.max(-radius + 1, Math.min(radius - 1, x + spacing / 2 - width / 2));
          const y = radius - Math.sqrt(radius * radius - dx * dx);
          const angle = Math.asin(dx / radius) * 180 / Math.PI;
          item.style.transform = `translate(${x.toFixed(1)}px, ${y.toFixed(1)}px) rotate(${angle.toFixed(2)}deg)`;
        });
      }
    }
    customElements.define('cart-empty-carousel', CartEmptyCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
